import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import { api } from '../lib/api.ts';
import { useRefreshMe } from '../lib/auth.tsx';
import { getSessionAbsolute, useSessionExpiry } from '../lib/session.ts';
import { fmtTime } from '../lib/date.ts';

/** 상단 바의 로그아웃 잔여시간. 10분 미만일 때만 표시(CR-023), 5분 미만이면 빨강, 0 이면 로그인 화면으로. "연장" 은 /auth/me 호출로 유휴 시간을 갱신한다. */
export function SessionTimer() {
  const expiresAt = useSessionExpiry();
  const refresh = useRefreshMe();
  const nav = useNavigate();
  const [now, setNow] = useState(Date.now());
  useEffect(() => { const t = window.setInterval(() => setNow(Date.now()), 1000); return () => window.clearInterval(t); }, []);
  useEffect(() => { if (expiresAt !== null && expiresAt - now <= 0) { refresh(); nav('/login', { replace: true }); } }, [expiresAt, now]); // eslint-disable-line
  if (expiresAt === null) return null;
  const left = Math.max(0, expiresAt - now);
  if (left >= 10 * 60000) return null; // CR-023: 10분 미만일 때만 보인다
  const m = Math.floor(left / 60000), s = Math.floor((left % 60000) / 1000);
  const warn = left < 5 * 60000;
  const abs = getSessionAbsolute();
  const absLeft = abs ? Math.max(0, abs - now) : null;
  const extendable = absLeft === null || absLeft > left + 60000; // 절대 만료가 더 남아 있을 때만 연장 의미 있음
  return (
    <span className={`flex items-center gap-1.5 px-2 py-0.5 tabular-nums ${warn ? 'bg-red-50 text-red-700 border border-red-200' : 'bg-white border border-accent-muted text-slate-600'}`} title={abs ? `절대 만료 ${fmtTime(abs)}` : undefined}>
      <span>{warn ? '곧 로그아웃' : '자동 로그아웃'}</span>
      <b>{m}:{String(s).padStart(2, '0')}</b>
      {extendable && <button className="text-accent-strong hover:underline" onClick={() => api('/auth/me')}>연장</button>}
    </span>
  );
}
